<template>
  <div id="lista-de-solicitacoes" class="column">
    <div class="container container_com-fundo container_com-margem">
      <div class="logos print has-text-centered">
        <img src="../../assets/imagens/logo-relatorio-retrato.jpg" />
      </div>
      <div class="filtros-escolhidos print">
        <h2 v-show="somenteFiltroDeSituacaoEstaSelecionado()" class="title-print">
          DEMONSTRATIVO DE SUBSÍDIOS
        </h2>
        <div class="filtros-escolhidos-itens">
          <ul>
            <li>
              Projeto:
              <span>{{ filtroDeProjetoSelecionado() }}</span>
            </li>
            <li>
              Cidade: <span>{{ filtroDeCidadeSelecionado() }}</span>
            </li>
            <li>
              Empreendimento:
              <span>{{ filtroDeEmpreendimentoSelecionado() }}</span>
            </li>
            <li>
              Situação: <span>{{ filtroDeSituacaoSelecionado() }}</span>
            </li>
            <li>
              Total de solicitações:
              <span>{{ solicitacoes.length }}</span>
            </li>
            <li>
              Impresso em:
              <span>
                {{ new Date().toLocaleDateString('pt-BR') }}
              </span>
            </li>
          </ul>
          <div class="valor-total">
            Total: <strong>{{ exibirComoMoeda(somatorioSubsidios) }}</strong>
          </div>
        </div>
      </div>

      <div class="columns search buscar-solicitacoes no-print">
        <form @submit.prevent="filtrarSolicitacoes" class="formulario">
          <div class="grade__linha grade__linha_alinhar-vertical-a-base linha-de-filtros">
            <div class="grade__coluna">
              <label for="nome">Nome do proponente</label>
              <input
                v-model="nome"
                id="nome"
                name="nome"
                type="text"
                maxlenght="90"
                placeholder="Ex. Ana maria da Silva"
              />
            </div>

            <div class="grade__coluna">
              <label for="construtora">Construtora</label>
              <combobox
                id="construtora"
                name="construtora"
                v-model="construtoraId"
                :opcoes="opcoesDeConstrutoras"
                pesquisavel
                rotulo-sem-selecao="Todas as construtoras"
              />
            </div>

            <div class="grade__coluna">
              <label for="projeto">Projeto</label>
              <combobox
                id="projeto"
                name="projeto"
                v-model="projeto"
                :opcoes="opcoesDeProjetos"
                rotulo-sem-selecao="Todos os projetos"
                @selecionar="redefinirFiltrosDeBusca"
              />
            </div>

            <div class="grade__coluna">
              <label for="empreendimento">Empreendimento</label>
              <combobox
                id="empreendimento"
                name="empreendimento"
                v-model="empreendimento"
                :opcoes="opcoesDeEmpreendimentos"
                :desabilitado="carregandoEmpreendimentos"
                :rotulo-sem-selecao="
                  carregandoEmpreendimentos ? 'Carregando...' : 'Todos os empreendimentos'
                "
                pesquisavel
              />
            </div>

            <div class="grade__coluna">
              <label for="numeroDoProcesso">Processo</label>
              <input
                v-model="numeroDoProcesso"
                id="numeroDoProcesso"
                name="numeroDoProcesso"
                type="text"
                maxlenght="15"
                placeholder="XX/XXX.XXX/XXXX"
                v-mask="'99/999.999/9999'"
              />
            </div>
          </div>

          <div class="grade__linha grade__linha_alinhar-vertical-a-base linha-de-filtros">
            <div class="grade__coluna">
              <label for="cpf">CPF</label>
              <input
                v-model="cpf"
                id="cpf"
                name="cpf"
                type="text"
                class="campos-tamanho-pequeno"
                maxlenght="90"
                placeholder="000.000.000-00"
                v-mask="'999.999.999-99'"
              />
            </div>

            <div class="grade__coluna">
              <label for="cnpjDaConstrutora">CNPJ da construtora</label>
              <input
                v-model="cnpjDaConstrutora"
                id="cnpjDaConstrutora"
                name="cnpjDaConstrutora"
                type="text"
                placeholder="00.000.000/0001-00"
                v-mask="'99.999.999/9999-99'"
              />
            </div>

            <div class="grade__coluna">
              <label for="situacao">Situação</label>
              <combobox
                id="situacao"
                name="situacao"
                v-model="situacao"
                :opcoes="situacoes"
                :desabilitado="carregandoSituacoes"
                :rotulo-sem-selecao="carregandoSituacoes ? 'Carregando...' : 'Todas as situações'"
                :rotulo-de-selecionados="rotuloDeSituacoesSelecionadas"
                multiplo
                preservar-ordem
              >
                <template slot="opcao" slot-scope="{ opcao }">
                  <span :class="['tags', classeCssDaCor('tags', opcao.cor)]">{{
                    opcao.texto
                  }}</span>
                </template>
              </combobox>
            </div>

            <div class="grade__coluna">
              <label for="cidade">Cidade do empreendimento</label>
              <combobox
                id="cidade"
                name="cidade"
                v-model="cidade"
                :opcoes="opcoesDeCidades"
                :desabilitado="carregandoCidades"
                :rotulo-sem-selecao="carregandoCidades ? 'Carregando...' : 'Todas as cidades'"
                pesquisavel
                @selecionar="preservarEmpreendimentoAoTrocarCidade"
              />
            </div>

            <div class="grade__coluna">
              <label for="periodo">Período</label>
              <date-picker
                :range-separator="'  até  '"
                :format="'DD/MM/YYYY'"
                v-model="periodo"
                type="date"
                range
                placeholder="dd/mm/aaaa"
              ></date-picker>
            </div>
          </div>

          <div class="grade__linha" v-if="errosDeValidacao.length > 0">
            <div class="grade__coluna">
              <div role="alert" class="mensagem mensagem_cor-erro">
                <i class="far fa-times-circle mensagem__icone"></i>
                <div class="mensagem__conteudo">
                  <ul class="mensagem__texto lista-de-erros-do-filtro">
                    <li v-for="erro in errosDeValidacao" :key="erro">
                      {{ erro }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <mensagem-flutuante
            titulo="Identificamos um erro:"
            :texto="erroDaConsulta"
            estilo="erro"
            icone="fa-info-circle"
            :mensagem-visivel="!!erroDaConsulta"
            @close="erroDaConsulta = null"
          />

          <div class="grade__linha grade__linha_alinhar-vertical-a-base">
            <div class="grade__coluna">
              <div class="faixa-de-acoes-dos-filtros">
                <button type="submit" class="botao botao_cor-primaria">Buscar</button>

                <button
                  v-if="existeAlgumFiltroPreenchido"
                  type="button"
                  class="botao botao_cinza botao_sem-preenchimento"
                  @click="limparFiltros"
                >
                  Limpar busca
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div class="container container_com-fundo container_com-margem">
      <loading :ativo="loading.visivel" :mensagem="loading.mensagem" />
      <table class="tabela tabela_listrada tabela_com-largura-total">
        <thead>
          <tr>
            <th>Proponente(s)</th>
            <th>CPF</th>
            <th>Empreendimento</th>
            <th>Cidade</th>
            <th>Situação</th>
            <th>Data da situação</th>
            <th class="no-print">Processo NUP</th>
            <th class="no-print">Operação bancária</th>
            <th>Subsídio</th>
            <th class="no-print">
              <span class="u-esconder-acessivel">Ações</span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="solicitacao of solicitacoes" :id="solicitacao.Id">
            <td>
              <div v-for="proponente in solicitacao.Proponentes">
                <p>{{ proponente.Nome }}</p>
                <p v-if="proponente.Conjuge">{{ proponente.Conjuge.Nome }}</p>
              </div>
            </td>
            <td>
              <div v-for="proponente in solicitacao.Proponentes">
                <p>{{ proponente.Cpf }}</p>
                <p v-if="proponente.Conjuge">{{ proponente.Conjuge.Cpf }}</p>
              </div>
            </td>
            <td>
              {{ solicitacao.Imovel.Empreendimento.Nome }}
            </td>
            <td>
              {{ solicitacao.Imovel.Endereco.Cidade.Nome }}
            </td>
            <td>
              <div
                :class="[
                  'tags',
                  classeCssDaCor(
                    'tags',
                    obterCorDoStatusDaSolicitacao(solicitacao.StatusDaSolicitacao)
                  ),
                ]"
              >
                {{ solicitacao.Status }}
              </div>
              <span class="print" v-if="solicitacao.InformacoesDoPagamento">
                <span class="mostrar-numero-da-ob">Nº da OB:</span>
                {{ solicitacao.InformacoesDoPagamento.OrdemBancaria }}</span
              >
            </td>
            <td>
              {{ solicitacao.DataDeUltimaAtualizacaoDeStatus }}
            </td>
            <td class="no-print">
              {{ solicitacao.NumeroDoProcesso ? solicitacao.NumeroDoProcesso : '---' }}
            </td>
            <td class="no-print">
              <template v-if="solicitacao.InformacoesDoPagamento">
                <div>{{ solicitacao.InformacoesDoPagamento.OrdemBancaria }}</div>
                <div v-if="solicitacao.InformacoesDoPagamento.OrdemBancariaComplementar">
                  {{ solicitacao.InformacoesDoPagamento.OrdemBancariaComplementar }}
                </div>
              </template>
              <template v-else>---</template>
            </td>
            <td>
              {{ exibirComoMoeda(solicitacao.Financiamento.SubsidioDaAgehab) }}
            </td>
            <td class="no-print">
              <div class="dropdown dropdown_direita">
                <button
                  class="botao botao_cor-terciaria botao_sem-preenchimento botao_pequeno botao-de-acoes-da-linha"
                  aria-haspopup="true"
                  aria-label="Ações da solicitação"
                >
                  <i class="far fa-ellipsis-vertical"></i>
                </button>
                <ul class="dropdown__lista" aria-label="Submenu">
                  <li
                    class="dropdown__item"
                    @click="abrirResumoDaSolicitacao(solicitacao.Id, solicitacao.ProjetoTipo)"
                  >
                    <a class="dropdown__link">
                      <i class="far fa-gear dropdown__icone"></i>
                      Gerenciar
                    </a>
                  </li>
                  <li
                    class="dropdown__item"
                    @click="
                      visualizarComprovanteDaSolicitacao(solicitacao.Id, solicitacao.ProjetoTipo)
                    "
                  >
                    <a class="dropdown__link">
                      <i class="far fa-print dropdown__icone"></i>
                      Imprimir
                    </a>
                  </li>
                </ul>
              </div>
            </td>
          </tr>
          <tr v-if="solicitacoes.length === 0">
            <td colspan="10">
              <div class="estado-vazio estado-vazio_largura-grande">
                <i class="far fa-empty-set estado-vazio__icone"></i>
                <h2 class="estado-vazio__titulo">Nenhum resultado encontrado</h2>
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <paginacao
        @paginar="obterSolicitacoes"
        :paginaAtual="paginaAtual"
        :totalDePaginas="totalDePaginas"
        :totalDeRegistros="totalDeRegistros"
        :quantidadePorPagina="quantidadePorPagina"
        exibirSemRegistros
      />
    </div>
  </div>
</template>

<script>
import AwesomeMask from 'awesome-mask';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/pt-br';
import obterCorDoStatusDaSolicitacao from '../../utils/statusDaSolicitacao';
import validarCnpj from '../../utils/validadorDeCnpj';
import Combobox from '../shared/Combobox';
import Loading from '../shared/Loading';
import MensagemFlutuante from '../shared/MensagemFlutuante';
import Paginacao from '../shared/Paginacao';
import FiltrosDaTela, { TELA_LISTA_DE_SOLICITACOES } from '../../utils/filtrosDaTela';

const MENSAGEM_DE_FALHA_NA_CONSULTA = 'Não foi possível realizar a consulta. Tente novamente.';

let filtrosJaLimposNesteCarregamentoDaPagina = false;

export default {
  checkIn: null,
  checkOut: null,
  name: 'lista-de-solicitacoes',
  directives: { mask: AwesomeMask },
  components: { Loading, MensagemFlutuante, Paginacao, DatePicker, Combobox },
  data() {
    return {
      paginaAtual: 1,
      totalDePaginas: 1,
      totalDeRegistros: 0,
      quantidadePorPagina: null,
      solicitacoes: [],
      empreendimentos: [],
      carregandoEmpreendimentos: true,
      carregandoCidades: true,
      carregandoSituacoes: true,
      projetos: [],
      construtoras: [],
      cidades: this.cidades || [],
      loading: {
        visivel: true,
      },
      nome: '',
      cpf: '',
      construtoraId: null,
      cnpjDaConstrutora: '',
      errosDeValidacao: [],
      erroDaConsulta: null,
      consultaEmAndamento: false,
      empreendimento: null,
      projeto: null,
      cidade: null,
      situacao: [],
      periodo: [],
      numeroDoProcesso: '',
      somatorioSubsidios: 0,
      situacoes: [],
    };
  },
  computed: {
    opcoesDeProjetos() {
      return this.projetos.map((projeto) => ({
        valor: projeto.Id,
        texto: projeto.Nome,
      }));
    },
    opcoesDeConstrutoras() {
      return this.construtoras.map((construtora) => ({
        valor: construtora.Id,
        texto: construtora.Nome,
      }));
    },
    opcoesDeEmpreendimentos() {
      return this.empreendimentos.map((empreendimento) => ({
        valor: empreendimento.Id,
        texto: empreendimento.Nome,
      }));
    },
    opcoesDeCidades() {
      return this.cidades.map((cidade) => ({
        valor: cidade.Id,
        texto: cidade.Nome,
      }));
    },
    existeAlgumFiltroPreenchido() {
      return (
        !!this.nome ||
        !!this.cpf ||
        !!this.construtoraId ||
        !!this.cnpjDaConstrutora ||
        !!this.numeroDoProcesso ||
        !!this.projeto ||
        !!this.empreendimento ||
        !!this.cidade ||
        this.situacao.length > 0 ||
        (Array.isArray(this.periodo) ? this.periodo : []).filter((data) => !!data).length > 0
      );
    },
  },
  created() {
    this.exibirCarregamento();

    if (this.paginaFoiRecarregada() && !filtrosJaLimposNesteCarregamentoDaPagina) {
      this.limparFiltrosPersistidos();
    }

    filtrosJaLimposNesteCarregamentoDaPagina = true;

    this.restaurarFiltrosPersistidos();

    Promise.all([
      this.obterProjetos(),
      this.obterConstrutoras(),
      this.obterCidades(),
      this.obterEmpreendimentos(),
      this.carregarSituacoes(this.projeto),
    ]).finally(() => {
      this.descartarFiltrosSemOpcaoCorrespondente();
      this.obterSolicitacoes(FiltrosDaTela.obter(TELA_LISTA_DE_SOLICITACOES).pagina, true);
    });
  },
  beforeDestroy() {
    var head = document.head || document.getElementsByTagName('head')[0];
    var styleDaImpressao = document.querySelectorAll('[media=print]');
    if (styleDaImpressao.length) head.removeChild(styleDaImpressao[0]);
    if (window.location.href.indexOf('detalhes-da-solicitacao') == -1) {
      this.limparFiltrosPersistidos();
    }
  },
  methods: {
    paginaFoiRecarregada() {
      const entradasDeNavegacao = !!performance.getEntriesByType
        ? performance.getEntriesByType('navigation')
        : [];

      if (entradasDeNavegacao.length > 0) return entradasDeNavegacao[0].type === 'reload';

      return !!performance.navigation && performance.navigation.type === 1;
    },
    limparFiltrosPersistidos() {
      FiltrosDaTela.remover(TELA_LISTA_DE_SOLICITACOES);
    },
    filtrarSolicitacoes() {
      this.errosDeValidacao = [];

      if (!!this.cnpjDaConstrutora && !validarCnpj(this.cnpjDaConstrutora)) {
        this.errosDeValidacao.push('CNPJ da construtora inválido.');
      }

      if (this.errosDeValidacao.length > 0) return;

      this.obterSolicitacoes(1);
    },
    limparFiltros() {
      this.nome = '';
      this.cpf = '';
      this.construtoraId = null;
      this.cnpjDaConstrutora = '';
      this.errosDeValidacao = [];
      this.projeto = null;
      this.empreendimento = null;
      this.cidade = null;
      this.situacao = [];
      this.periodo = [];
      this.numeroDoProcesso = '';

      this.recarregarListasDependentesDoProjeto();
      this.obterSolicitacoes(1, true);
    },
    obterSolicitacoes(pagina, esvaziarResultadosNaFalha = false) {
      if (this.consultaEmAndamento) return;

      this.consultaEmAndamento = true;
      this.erroDaConsulta = null;
      this.exibirCarregamento();
      this.persistirFiltros(pagina);

      const periodo = Array.isArray(this.periodo) ? this.periodo : [];

      let filtro = {
        nome: this.nome,
        empreendimentoId: this.empreendimento,
        projetoId: this.projeto,
        cidadeId: this.cidade,
        status: this.situacao,
        numeroDoProcesso: this.numeroDoProcesso,
        cpf: this.cpf,
        construtoraId: this.construtoraId,
        cnpjDaConstrutora: this.cnpjDaConstrutora,
        dataInicial: !!periodo[0] ? periodo[0] : null,
        dataFinal: !!periodo[1] ? periodo[1] : null,
        pagina: pagina,
      };

      this.$api
        .post('/Solicitacao/Filtrar', filtro)
        .then((response) => {
          this.solicitacoes = response.data.Modelo;
          this.paginaAtual = response.data.PaginaAtual;
          this.totalDePaginas = Math.max(response.data.TotalDePaginas, 1);
          this.totalDeRegistros = response.data.TotalDeRegistros;
          this.quantidadePorPagina = response.data.QuantidadePorPagina;
          this.solicitacoes.forEach((solicitacao) => {
            this.somatorioSubsidios += solicitacao.Financiamento.SubsidioDaAgehab;
          });
        })
        .catch((error) => {
          console.error(error);
          this.erroDaConsulta = MENSAGEM_DE_FALHA_NA_CONSULTA;
          setTimeout(() => {
            this.erroDaConsulta = null;
          }, 10000);

          if (esvaziarResultadosNaFalha) this.esvaziarResultados();
        })
        .finally(() => {
          this.consultaEmAndamento = false;
          this.esconderCarregamento();
        });
    },
    esvaziarResultados() {
      this.solicitacoes = [];
      this.paginaAtual = 1;
      this.totalDePaginas = 1;
      this.totalDeRegistros = 0;
    },
    restaurarFiltrosPersistidos() {
      const filtros = FiltrosDaTela.obter(TELA_LISTA_DE_SOLICITACOES);

      this.nome = filtros.nome || '';
      this.cpf = filtros.cpf || '';
      this.projeto = this.comoIdentificador(filtros.projeto);
      this.cidade = this.comoIdentificador(filtros.cidade);
      this.empreendimento = this.comoIdentificador(filtros.empreendimento);
      this.construtoraId = this.comoIdentificador(filtros.construtoraId);
      this.situacao = Array.isArray(filtros.situacao) ? filtros.situacao : [];
      this.periodo = this.mapearPeriodo(filtros.periodo);
      this.paginaAtual = filtros.pagina ? parseInt(filtros.pagina) : 1;
      this.numeroDoProcesso = filtros.numeroDoProcesso || '';
      this.cnpjDaConstrutora = filtros.cnpjDaConstrutora || '';
    },
    comoIdentificador(valor) {
      const identificador = parseInt(valor);

      return Number.isNaN(identificador) ? null : identificador;
    },
    descartarFiltrosSemOpcaoCorrespondente() {
      this.projeto = this.valorComOpcaoNaLista(this.projeto, this.opcoesDeProjetos);
      this.construtoraId = this.valorComOpcaoNaLista(this.construtoraId, this.opcoesDeConstrutoras);
      this.cidade = this.valorComOpcaoNaLista(this.cidade, this.opcoesDeCidades);
      this.empreendimento = this.valorComOpcaoNaLista(
        this.empreendimento,
        this.opcoesDeEmpreendimentos
      );
      this.situacao = this.situacao.filter((situacaoPersistida) =>
        this.situacoes.some((opcao) => opcao.valor === situacaoPersistida)
      );
    },
    valorComOpcaoNaLista(valor, opcoes) {
      return opcoes.some((opcao) => opcao.valor === valor) ? valor : null;
    },
    preservarEmpreendimentoAoTrocarCidade() {
      const selecionado = this.empreendimentos.find(
        (empreendimento) => empreendimento.Id === this.empreendimento
      );

      return this.obterEmpreendimentos().then(() => {
        if (!selecionado) return;

        const continuaNaLista = this.empreendimentos.some(
          (empreendimento) => empreendimento.Id === selecionado.Id
        );

        if (!continuaNaLista) this.empreendimentos = this.empreendimentos.concat(selecionado);
      });
    },
    redefinirFiltrosDeBusca() {
      this.empreendimento = null;
      this.situacao = [];

      this.recarregarListasDependentesDoProjeto();
    },
    recarregarListasDependentesDoProjeto() {
      this.empreendimentos = [];
      this.situacoes = [];

      this.obterEmpreendimentos();
      this.carregarSituacoes(this.projeto);
    },
    mapearPeriodo(periodo) {
      if (!Array.isArray(periodo) || periodo.length === 0) return [];

      return periodo.filter((p) => p !== null).map((p) => new Date(p));
    },
    persistirFiltros(pagina) {
      FiltrosDaTela.salvar(TELA_LISTA_DE_SOLICITACOES, {
        nome: this.nome,
        cpf: this.cpf,
        empreendimento: this.empreendimento,
        projeto: this.projeto,
        cidade: this.cidade,
        situacao: this.situacao,
        periodo: Array.isArray(this.periodo) ? this.periodo : [],
        numeroDoProcesso: this.numeroDoProcesso,
        construtoraId: this.construtoraId,
        cnpjDaConstrutora: this.cnpjDaConstrutora,
        pagina: pagina,
      });
    },
    exibirCarregamento() {
      this.loading.visivel = true;
    },
    esconderCarregamento() {
      this.loading.visivel = false;
      window.scrollTo(0, 0);
    },
    obterProjetos() {
      return this.$api
        .get('/Projeto/ObterVigentes')
        .then((response) => {
          this.projetos = response.data;

          return response;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    obterConstrutoras() {
      return this.$api
        .get('/Construtora')
        .then((response) => {
          this.construtoras = response.data;

          return response;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    obterCidades() {
      this.carregandoCidades = true;

      return this.$api
        .get('/Cidade/ObterCidadesDosEmpreendimentos')
        .then((response) => {
          this.cidades = response.data;

          return response;
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.carregandoCidades = false;
        });
    },
    obterEmpreendimentos() {
      const projetoId = this.projeto;
      this.carregandoEmpreendimentos = true;

      return this.$api
        .get('/Empreendimento/', {
          cidadeId: this.cidade,
          projetoId: projetoId,
        })
        .then((response) => {
          if (projetoId !== this.projeto) {
            return response;
          }

          this.empreendimentos = response.data;

          return response;
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          if (projetoId === this.projeto) {
            this.carregandoEmpreendimentos = false;
          }
        });
    },
    obterStatusDaSolicitacao(projetoId) {
      return new Promise((resolve, reject) => {
        this.$api
          .get('/Solicitacao/ObterStatusDaSolicitacao', {
            projetoId: projetoId,
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    carregarSituacoes(projetoId) {
      this.carregandoSituacoes = true;

      return this.obterStatusDaSolicitacao(projetoId)
        .then((resultado) => {
          if (projetoId !== this.projeto) {
            return;
          }

          this.situacoes = resultado.data.map((statusDaSolicitacao) => {
            return {
              valor: statusDaSolicitacao.Id,
              texto: statusDaSolicitacao.Descricao,
              cor: obterCorDoStatusDaSolicitacao(statusDaSolicitacao.Id),
            };
          });
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          if (projetoId === this.projeto) {
            this.carregandoSituacoes = false;
          }
        });
    },
    exibirComoMoeda(valor) {
      return this.$moeda.formatar(valor);
    },
    classeCssDaCor(bloco, cor) {
      return cor ? `${bloco}_cor-${cor.toLowerCase()}` : '';
    },
    obterCorDoStatusDaSolicitacao,
    somenteFiltroDeSituacaoEstaSelecionado() {
      return this.nome === '' && !this.empreendimentoSelecionado() && this.situacao.length > 0;
    },
    empreendimentoSelecionado() {
      if (!this.empreendimento) return null;

      return (
        this.empreendimentos.find((empreendimento) => empreendimento.Id === this.empreendimento) ||
        null
      );
    },
    rotuloDeSituacoesSelecionadas(quantidade) {
      return quantidade === 1 ? '1 situação selecionada' : `${quantidade} situações selecionadas`;
    },
    filtroDeSituacaoSelecionado() {
      const selecionadas = this.situacao
        .map((valor) => this.situacoes.find((opcao) => opcao.valor === valor))
        .filter((opcao) => !!opcao)
        .map((opcao) => opcao.texto);

      return selecionadas.length > 0 ? selecionadas.join(', ') : 'TODAS';
    },
    filtroDeEmpreendimentoSelecionado() {
      const empreendimento = this.empreendimentoSelecionado();
      return !!empreendimento ? empreendimento.Nome : 'TODOS';
    },
    filtroDeCidadeSelecionado() {
      if (!this.cidade) return 'TODAS';

      const cidadeSelecionada = this.cidades.find((cidade) => cidade.Id === this.cidade);
      return !!cidadeSelecionada ? cidadeSelecionada.Nome : 'TODAS';
    },
    filtroDeProjetoSelecionado() {
      if (!this.projeto) return 'TODOS';
      let projetoSelecionado = this.projetos.find((projeto) => projeto.Id == this.projeto);
      return !!projetoSelecionado ? projetoSelecionado.Nome : 'TODOS';
    },
    imprimirComOrientacaoPaisagem(orientacaoEhPaisagem) {
      var css;

      if (orientacaoEhPaisagem) {
        css = '@page { size: landscape; }';
      } else {
        css = '@page { size: portrait; }';
      }

      var head = document.head || document.getElementsByTagName('head')[0];
      var style = document.createElement('style');

      style.type = 'text/css';
      style.media = 'print';

      if (style.styleSheet) {
        style.styleSheet.cssText = css;
      } else {
        style.appendChild(document.createTextNode(css));
      }

      head.appendChild(style);

      window.print();
    },
    abrirResumoDaSolicitacao(solicitacaoId, projetoTipo) {
      let nomeDaRota =
        projetoTipo == 'McmvCidades'
          ? 'DetalhesDaSolicitacaoParaMcmvCidades'
          : 'DetalhesDaSolicitacao';
      this.$router.push({
        name: nomeDaRota,
        query: { idDaSolicitacao: solicitacaoId },
      });
    },
    visualizarComprovanteDaSolicitacao(solicitacaoId, projetoTipo) {
      let nomeDaRota =
        projetoTipo == 'McmvCidades' ? 'VisualizarSolicitacaoMcmv' : 'VisualizarSolicitacao';
      this.$router.push({
        name: nomeDaRota,
        query: { idDaSolicitacao: solicitacaoId },
      });
    },
  },
};
</script>

<style scoped>
.buscar-solicitacoes .faixa-de-acoes-dos-filtros .botao {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  padding: 0 16px;
  margin-top: 0;
}

.lista-de-erros-do-filtro {
  list-style: none;
  margin: 0;
  padding: 0;
}

.lista-de-erros-do-filtro li + li {
  margin-top: 4px;
}

@media (min-width: 600px) and (max-width: 899px) {
  .buscar-solicitacoes .linha-de-filtros .grade__coluna {
    flex: 0 0 50%;
    max-width: 50%;
  }
}
</style>



// WEBPACK FOOTER //
// ListaDeSolicitacoes.vue?8d4e6ae6